import { showCustomToast } from 'common/components/CustomToast/utils';
import React from 'react';
import { useMutation } from '@apollo/client';
import {
  CreateMessageData,
  CreateNewMessage,
} from 'common/components/CreateNewMessage';

import { PivotKeys } from 'common/components/MessagesSections';
import {
  BatchCreateMessage,
  BatchCreateMessageVariables,
} from './__generated__/BatchCreateMessage';
import BATCH_MESSAGE_TRANSACTION_CREATE from './BatchCreateMessage.graphql';
import BATCH_MESSAGES from '../BatchTransactionMessagesView.graphql';
interface NewMessageProps {
  batchID: string;
  selectedKey: string;
  onCreateMessage: () => void;
}

export const NewMessage: React.FC<NewMessageProps> = ({
  batchID,
  selectedKey,
  onCreateMessage,
}) => {
  const [createMessage, { loading }] = useMutation<
    BatchCreateMessage,
    BatchCreateMessageVariables
  >(BATCH_MESSAGE_TRANSACTION_CREATE);

  const messageFilter =
    selectedKey === PivotKeys.sent
      ? { _isOutgoingMessage: { equalTo: true } }
      : { _isIncomingMessage: { equalTo: true } };

  const onSubmit = async (formData: CreateMessageData) => {
    const { messageComment, reminderDates, isResponseRequired, receivers } = {
      ...formData,
    };
    const { communicationChannel, department, user } = { ...receivers };
    const { errors } = await createMessage({
      variables: {
        input: {
          entityId: batchID,
          message: { messageComment, reminderDates, isResponseRequired },
          communicationChannel,
          department,
          user,
        },
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: BATCH_MESSAGES,
          variables: {
            id: batchID,
            first: 10,
            filter: messageFilter,
          },
        },
      ],
    });

    if (!errors) {
      onCreateMessage();
      showCustomToast({
        content: 'Message sent successfully.',
        appearance: 'success',
      });
    } else
      showCustomToast({
        content: `${errors[0].message}`,
        appearance: 'error',
      });
  };

  return <CreateNewMessage onSubmit={onSubmit} loading={loading} />;
};
